"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var _require = require("../helpers/create-event-accessor"),
    setupForSimpleEventAccessors = _require.setupForSimpleEventAccessors;

var _require2 = require("../helpers/events"),
    fireAnEvent = _require2.fireAnEvent;

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var AbortSignalImpl = /*#__PURE__*/function (_EventTargetImpl) {
  _inherits(AbortSignalImpl, _EventTargetImpl);

  var _super = _createSuper(AbortSignalImpl);

  function AbortSignalImpl(args, privateData) {
    var _this;

    _classCallCheck(this, AbortSignalImpl);

    _this = _super.call(this); // make event firing possible

    _this._ownerDocument = privateData.window.document;
    _this.aborted = false;
    _this.abortAlgorithms = new Set();
    return _this;
  }

  _createClass(AbortSignalImpl, [{
    key: "_signalAbort",
    value: function _signalAbort() {
      if (this.aborted) {
        return;
      }

      this.aborted = true;

      var _iterator = _createForOfIteratorHelper(this.abortAlgorithms),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var algorithm = _step.value;
          algorithm();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.abortAlgorithms.clear();
      fireAnEvent("abort", this);
    }
  }, {
    key: "_addAlgorithm",
    value: function _addAlgorithm(algorithm) {
      if (this.aborted) {
        return;
      }

      this.abortAlgorithms.add(algorithm);
    }
  }, {
    key: "_removeAlgorithm",
    value: function _removeAlgorithm(algorithm) {
      this.abortAlgorithms.delete(algorithm);
    }
  }]);

  return AbortSignalImpl;
}(EventTargetImpl);

setupForSimpleEventAccessors(AbortSignalImpl.prototype, ["abort"]);
module.exports = {
  implementation: AbortSignalImpl
};